/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { Button, Card, Skeleton } from '@ui/components';

export const DefaultCardExample = () => (
    <Card>Use cards for generic grouped MVC content.</Card>
);

export const TitledCardExample = () => (
    <Card title="Campaign summary">Campaign details go here.</Card>
);

export const ActionSlotCardExample = () => (
    <Card actions={<Button variant="secondary">View details</Button>}>
        Content with a caller-owned action slot.
    </Card>
);

export const LongContentCardExample = () => (
    <Card title="Long content">
        Cards can contain longer explanatory content without owning feature
        workflow, routing, sponsor, rightsholder, report, or placement behavior.
    </Card>
);

export const LoadingCompatibleCardExample = () => (
    <Card title="Loading state">
        <Skeleton active paragraph={{ rows: 3 }} />
    </Card>
);
